import React, { useState } from 'react';
import {Link, useNavigate, useLocation} from 'react-router-dom';
import { Menu, Divider, Popconfirm } from 'antd';
import { UserOutlined, ExportOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { selectMenus, selectName, signOut } from '../../features/auth/authSlice';
import './LayoutDefault.less';
import { FormattedMessage, useIntl } from 'react-intl';
import { getParentMenuCode } from '@/app/routes';
import QRCode from 'qrcode.react';
import LanguageSetting from "../language/LanguageSetting";

function LayoutDefault({ children, menu }) {
  let year = new Date().getFullYear();
  return (
    <div className="layout-default">
      <div className="app-header-container">
        <div className="app-header-wrapper">
          <div className="abb-bar">
            <FormattedMessage id="layout.appname" />
          </div>
          <div className="app-header-bar">
            <Navbar currentMenu={menu} />
            <Toolbar />
          </div>
        </div>
      </div>
      <div className="app-body-container">
        <div className="app-body-wrapper">{children}</div>
      </div>
      <div className="app-footer-container">
        <div className="app-footer-wrapper">&copy; {year} ABB</div>
      </div>
    </div>
  );
}

export default LayoutDefault;

// child component
function Navbar({ currentMenu }) {
  // component
  const { SubMenu } = Menu;
  // selector
  const menus = useSelector(selectMenus);
  const intl = useIntl();

  currentMenu = getParentMenuCode(currentMenu);

  function getMenuItems(items) {
    var datas = [];
    if(items.length === 0) {
      return items;
    }

    items.forEach(item => {
      var menuName = intl.formatMessage({
        id: `menu.${item.menuCode}`,
        defaultMessage: item.menuName,
      });

      var data = {
        label: menuName,
        key: item.menuCode
      };

      if (item.children && item.children.length > 0) {
        data.children = getMenuItems(item.children);
      } else {
        if (/^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/.test(item.url)) {
          data.label = (
            <a target="_blank" href={item.url} rel="noreferrer">
              {menuName}
            </a>
          );
        } else {
          data.label = (
            <Link to={item.url}>{menuName}</Link>
          );
        }
      }

      datas.push(data);
    });

    return datas;
  }

  return (
    <Menu className="topmenus" selectedKeys={[currentMenu]} mode="horizontal" items={getMenuItems(menus)} />
  );
}

function Toolbar() {
  var navigate=useNavigate();
  const dispatch = useDispatch();
  const name = useSelector(selectName);
  const qrcodeUrl = window.ENV_CFG.api_root + '/#/mobile/login';
  const handleLogout = () => {
    dispatch(signOut());
    window.location.href = window.ENV_CFG.signout;
  };

  return (
    <div className="app-header-bar-controls">
      <Popconfirm
        placement="bottom"
        icon={null}
        title={null}
        description={
          <div style={{margin: '8px 8px 0 8px'}}>
            <QRCode value={qrcodeUrl} size={200}/>
          </div>
        }
        showCancel={false}
        destroyTooltipOnHide={true}
        id='noButtonPopconfirm'
      >
        <div className="control-item">
          <QrcodeOutlined />
        </div>
      </Popconfirm>
      <Divider type="vertical" />
      <div className='control-item'>
        <LanguageSetting />
      </div>
      <Divider type="vertical" />
      <div className="control-item">
        <UserOutlined />
        {name}
      </div> 
      <Divider type="vertical" />
      <div className="control-item" onClick={handleLogout}>
        <ExportOutlined />
      </div> 
    </div>
  );
}
